import React from 'react';

export default function LoanPagination({ page, pages, total, setPage }) {
  return <nav aria-label="Loan pages" style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '12px 0' }}>
    <button type="button" disabled={page === 1} onClick={() => setPage(page - 1)}>Previous</button>
    <span>Page {page} of {pages} · {total.toLocaleString()} loans</span>
    <button type="button" disabled={page === pages} onClick={() => setPage(page + 1)}>Next</button>
  </nav>;
}
